import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { ROOT } from 'configs/routeNames';

const PageNotFound = () => {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col items-center justify-center h-full gap-4 font-figtree">
      <h1 className="text-4xl font-bold">404</h1>
      <p className="text-gray-500">This page doesn&apos;t exist.</p>
      <Button type="primary" onClick={() => navigate(ROOT)}>
        Go to Dashboard
      </Button>
    </div>
  );
};

export default PageNotFound;
